import { render } from "./LoadingOvalIcon.vue?vue&type=template&id=15af1722"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__